<template>
  <div class="card card-info">
    <div class="card-header">
      <h3 class="card-title">Manage</h3>
    </div>
    <form v-on:submit="save">
      <div class="card-body">
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label>Session *</label>
              <select required class="form-control" v-model="semesterid">
                <option value="" selected="selected" disabled="disabled">--Select Session--</option>
                <option v-for="item in semesters" v-bind:value="item.SemesterID">{{item.Name}}</option>
              </select>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>Degree *</label>
              <select required class="form-control" v-model="degreeId" id="ddlSession" >
                <option value="" selected="selected" disabled="disabled">--Select Degree--</option>
                <option v-for="item in loadDegrees" v-bind:value="item.DegreeID">{{item.Name}}</option>
              </select>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>Category *</label>
              <select required class="form-control" v-model="catID" v-on:change="loadProgram">
                <option value="" selected="selected" disabled="disabled">--Select Category--</option>
                <option v-for="item in categories" v-bind:value="item.AdmissionCategoryID">{{item.Name}}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="row" v-show="Programs.length > 0">
          <div class="col-md-12">
            <label>Program List</label>
            <div>
              <table id="example2" class="table table-bordered table-color table-sm">
                <thead class="bg-info">
                  <tr>

                    <th style="width: 5px; text-align: center">Sr.#</th>
                    <th style="width: 55%">Program Name</th>
                    <th style="width: 15%">No of Seats</th>
                    <th style="width: 12%;">Start Date</th>
                    <th style="width: 12%;">End Date</th>
                    <th style="width: 5px;">Open</th>
                    <th style="width: 5px;">Internal Test</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style="text-align: center" colspan="3">Apply on All</td>
                    <th style="width: 15%;">
                      <input type="date" v-model="applyall.startDate" placeholder="Start Date" v-on:change="applyAlldatechange()" class="form-control pull-right">
                    </th>
                    <th style="width: 15%;">
                      <input type="date" v-model="applyall.endDate" v-on:change="applyallendchange()" class="form-control pull-right">
                    </th>
                    <th style="width: 5px; text-align: center">
                      <input type="checkbox" v-model="applyall.status" value="1" v-on:change="statusChange()" />
                    </th>
                    <th style="width: 5px; text-align: center">
                      <input type="checkbox" v-model="applyall.test" v-bind:disabled="!applyall.status" value="1" v-on:change="testChange()" />
                    </th>
                  </tr>

                  <tr v-for="(item, index) in Programs">
                    <td style="text-align: center">{{index + 1}}</td>
                    <td>{{item.ProgramName}}</td>
                    <td>
                      <input type="text" class="form-control" v-bind:disabled="!item.status" required="required" v-mask="'####'" v-model="item.NoOfSeats" />
                    </td>
                    <td>
                      <input type="date" class="form-control" v-bind:disabled="!item.status" required="required" v-model="item.startDate" v-on:change="startchange(index)" />
                    </td>
                    <td>
                      <input type="date" v-bind:disabled="!item.status" class="form-control" required="required" v-model="item.endDate" v-on:change="endchange(index)" />
                    </td>
                    <td style="width: 10%; text-align: center">
                      <input type="checkbox" v-model="item.status" value="1" />
                    </td>
                    <td style="width: 10%; text-align: center">
                      <input type="checkbox" v-bind:disabled="!item.status" v-model="item.InternalTest" value="1" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <button type="button" class="btn btn-primary">Print</button>
        <input type="submit" value="Save" class="btn btn-success float-right" />
      </div>
    </form>
  </div>
</template>

<script>

  const axios = require('axios').default;

  export default ({
    data() {
      return {
        applyall: { startDate: '', endDate: '', status: false, test: false },
        loadDegrees: [],
        Programs: [],
        degreeId: '',
        semesterid: '',
        catID: '',
        categories: [],
        semesters: [],
      }
    },

    created: function () {
      this.pageLoad();
    },

    methods: {
      pageLoad() {
        var vm = this;
        startReq();
        axios.get("/api/AdmissionApi/pageLoadAdmissionOffered")
          .then(function (res) {
            endReq();
            if (res.data.status) {
              vm.semesters = res.data.semester;
              vm.loadDegrees = res.data.degree;
              vm.categories = res.data.categories;
            }
            else {
              toastr.error(res.data.msg);
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      },

      loadProgram() {
        startReq();
        var vm = this;
        var querystring = '?semID=' + vm.semesterid + '&degID=' + vm.degreeId + '&catID=' + vm.catID;
        axios.get('/api/AdmissionApi/loadProgramsAdmssionOffered' + querystring)
          .then(function (res) {
            endReq();
            if (res.data.status) {
              vm.Programs = res.data.lst;
            }
            else {
              toastr.error(res.data.msg);
            }
          })
          .catch(function (res) {
            console.log(error);
          });
      },

      applyAlldatechange() {
        if (this.applyall.startDate > this.applyall.endDate && this.applyall.endDate != "") {
          toastr.error("Start date cannot be greater than End date", "Error!");
          return;
        }

        for (var i = 0; i < this.Programs.length; i++) {

          this.Programs[i].startDate = this.applyall.startDate

        }
      },

      statusChange() {
        for (var i = 0; i < this.Programs.length; i++) {

          this.Programs[i].status = this.applyall.status;

        }
      },

      testChange() {
        for (var i = 0; i < this.Programs.length; i++) {

          this.Programs[i].InternalTest = this.applyall.test;

        }
      },

      applyallendchange() {
        if (this.applyall.endDate < this.applyall.startDate && this.applyall.startDate != "") {
          toastr.error("Start date cannot be greater than End date", "Error!");
          return;
        }


        for (var i = 0; i < this.Programs.length; i++) {

          this.Programs[i].endDate = this.applyall.endDate

        }
      },

      startchange(i) {
        if (this.Programs[i].startDate > this.Programs[i].endDate && this.Programs[i].endDate != "") {
          toastr.error("Start date cannot be greater than End date", "Error!");
          this.Programs[i].startDate = "";
          return;
        }

      },

      endchange(i) {
        if (this.Programs[i].endDate < this.Programs[i].startDate && this.Programs[i].startDate != "") {
          toastr.error("End date cannot be smaller than Start date", "Error!");
          this.Programs[i].endDate = "";
          return;
        }
      },

      save(e) {
        e.preventDefault();
        var vm = this;
        startReq();
        axios.post('/api/AdmissionApi/saveAdmissionOffered?semID=' + vm.semesterid + '&degID=' + vm.degreeId + '&catID=' + vm.catID, {
          prog: vm.Programs
        })
          .then(function (res) {
            endReq();
            if (res.data.status) {
              toastr.success("Saved Successfully", "Done");
              vm.clear();
            }
            else
              toastr.error(res.data.msg);

          })
          .catch(function (err) {
            endReq();
            if (err.response) {
              var res = err.response;
              if (res.status == 401) {
                toastr.error(res.data);
              }
              else {
                for (const [key, value] of Object.entries(res.data.errors)) {
                  //console.log(`${value}`);
                  toastr.error(`${value}`);
                }
              }
            }
          })
      },

      clear() {
        this.applyall = { startDate: '', endDate: '', status: false, test: false };
        this.Programs = [];
        this.degreeId = '';
        this.semesterid = '';
        this.catID = '';
      }
    }
  })
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/onlineadmission/AdmissionOffered.vue